import { render, staticRenderFns } from "./CourseAuthor.vue?vue&type=template&id=3fbe90ce&scoped=true"
import script from "./CourseAuthor.vue?vue&type=script&lang=js"
export * from "./CourseAuthor.vue?vue&type=script&lang=js"
import style0 from "./CourseAuthor.vue?vue&type=style&index=0&id=3fbe90ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbe90ce",
  null
  
)

export default component.exports